import { Link, useRouterState } from '@tanstack/react-router';
import { Card } from '@tatra/ui';
import { Compass } from 'lucide-react';
import { useAuth } from '../../lib/auth.js';

/** Shown for any address the app does not know (an old link, a typo, a page that was removed). */
export function NotFoundPage() {
  const { status } = useAuth();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const signedIn = status === 'signed_in';
  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg p-4">
      <Card className="w-full max-w-sm p-6 text-center shadow-lg">
        <Compass className="mx-auto h-8 w-8 text-text-faint" aria-hidden="true" />
        <h1 className="mt-3 text-lg font-semibold text-text">Page not found</h1>
        <p className="mt-1 text-sm text-text-muted">
          There is nothing at <span className="break-all font-mono text-text">{path}</span>. The link may be
          old, or you may not have access to it.
        </p>
        <Link
          to={signedIn ? '/' : '/login'}
          className="mt-5 inline-flex min-h-11 w-full items-center justify-center rounded-md bg-primary px-3.5 text-sm font-medium text-primary-fg hover:bg-primary-hover md:min-h-9"
        >
          {signedIn ? 'Go to the home screen' : 'Go to sign in'}
        </Link>
      </Card>
    </main>
  );
}
